<template>
    <div class="xt-input" :style="receivedStyle" >
      <div v-if="label" class="xt-input__label">{{label}} <span style="font-size: 14px; color: #999;font-weight: 500" v-if="labelTip">{{labelTip}}</span></div>
        <div class="xt-input__container">
            <slot name="prefix" />
            <xt-selector v-if="type==='select'">
                <input class="xt-input__input"
                       :style="inputStyle ? inputStyle : ''"
                       v-model="currentValue"
                       @click="handleClick"
                       :placeholder="placeholder || ''"
                       readonly
                />
            </xt-selector>
            <input
                   v-else
                   :inputmode="inputmode"
                   class="xt-input__input"
                   :style="inputStyle ? inputStyle : ''"
                   :type="inputType"
                   v-model="currentValue"
                   :disabled="inputDisabled"
                   :readonly="inputReadOnly"
                   @click="handleClick"
                   @blur="handleBlur"
                   @input="inputload"
                   :placeholder="placeholder || ''"
                   :maxlength="maxlength"
            />
            <div style="margin-left:auto;">
                <slot name="subfix" />
            </div>
        </div>
        <div class="xt-input__error" v-if="errorShow" ><span v-if="errorMessage">{{errorMessage}}</span></div>
    </div>
</template>
<script>
import XtSelector from "./xtSelector";
export default {
  components: {XtSelector},
  props: {
    inputmode: {
      type: String,
    },
    label: {
      type: String,
      required: false
    },
    labelTip: {
      type: String,
      required: false
    },
    placeholder: {
      type: String,
      required: false
    },
    value: {
      type: [String, Number],
      default: ''
    },
    errorMessage: {
      type: String,
      required: false
    },
    inputStyle: {
      type: String,
      default: ''
    },
    inputType: {
      type: String,
      default: 'text'
    },
    inputReadOnly:{
      type: Boolean,
      default: false
    },
    inputDisabled: {
      type: Boolean,
      default: false
    },
    maxlength: {
      type: Number,
    },
    errorShow: {
      type: Boolean,
      default: true,
      required: false
    },
    type: {
      type: String,
      default: 'text'
    },
    receivedStyle: {
      type: String, // 接收字符串类型的样式
    },
  },
  data() {
    return {
      currentValue: this.value
    }
  },
  computed(){

  },
  watch: {
    value(val) {
      this.setCurrentValue(val);
    }
  },
  methods: {
    setCurrentValue(value) {
      if (value === this.currentValue) return;
      this.currentValue = value;
    },
    inputload(event){
      let value = event.target.value;
      this.$emit('input', value,event)
    },
    handleClick(event) {
      this.$emit('click', event)
    },
    handleBlur(event) {
      this.resetWindow()
      this.$emit('blur', event)
    }
  }

}
</script>
<style lang="less" scoped>
@import '../css/mobile.less';
.xt-input{
    width: 100%;
    margin-bottom: 20px;
    .xt-input__label{
        font-size: 18px;
        font-weight: 600;
        margin-bottom: 5px;
    }
    .xt-input__container{
        border-bottom: 1px solid @separate-line-color;
        height: 50px;
        line-height: 50px;
        display: flex;
        align-items: center;
        font-weight: 400;
        box-sizing: border-box;
        .xt-input__input{
            outline:none;
            box-shadow: none;
            background: none;
            border: 0;
            height: 30px;
            font-size: 16px;
            flex: 1;
            min-width: 70px;
        }
    }
    .xt-input__error{
        margin-top: 10px;
        font-size: 11px;
        color: #ff0000;
        height: 15px;
        line-height: 15px;
    }
}
</style>